var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var RadioIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M18.2222222,4 L5.77777778,4 C4.79111111,4 4,4.8 4,5.77777778 L4,18.2222222 C4,19.2 4.79111111,20 5.77777778,20 L18.2222222,20 C19.2088889,20 20,19.2 20,18.2222222 L20,5.77777778 C20,4.8 19.2088889,4 18.2222222,4 Z M8.44444444,11.1111111 L15.5555556,11.1111111 C16.0464753,11.1111111 16.4444444,11.5090802 16.4444444,12 C16.4444444,12.4909198 16.0464753,12.8888889 15.5555556,12.8888889 L8.44444444,12.8888889 C7.95352467,12.8888889 7.55555556,12.4909198 7.55555556,12 C7.55555556,11.5090802 7.95352467,11.1111111 8.44444444,11.1111111 Z" }))); };
export default RadioIcon;
